import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Feature from './Feature'
import Container from '../../Layout/Container'

const StyledFeatureList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  margin-top: ${({ extraTopMargin }) => (extraTopMargin ? '104px' : '18px')};
  padding: 0px 16px;

  li {
    margin-bottom: ${({ extraTopMargin }) => (extraTopMargin ? '104px' : '48px')};
  }

  ${({ theme }) => theme.media.desktop} {
    display: grid;
    grid-template-columns: auto auto auto;
    margin-top: 18px;
    padding: 0;

    li {
      grid-column: ${({ oddNumber }) => (oddNumber ? 'span 3' : 'auto')};
    }

    li:nth-last-child(2) {
      grid-column: ${({ oddNumber }) => (oddNumber ? '4 / span 6' : 'auto')};
      grid-row-start: ${({ oddNumber }) => (oddNumber ? '2' : 'auto')};
    }

    li:nth-last-child(1) {
      grid-column: ${({ oddNumber }) => (oddNumber ? '1 / span 6' : 'auto')};
      grid-row-start: ${({ oddNumber }) => (oddNumber ? '2' : 'auto')};
    }
  }
`

const FeatureList = ({ cmsData, features, oddNumber, wide, }) => {
  const isWide = (cmsData ? !!cmsData.wide : wide) || false
  const odd = (cmsData ? !!cmsData.oddNumber : oddNumber) || false
  const topMargin = cmsData ? true : false

  const data = cmsData
    ? cmsData.items.map(item => ({ ...item.fields, id: item.sys.id }))
    : features
    
  return (
    <Container>
      <StyledFeatureList extraTopMargin={topMargin} oddNumber={odd}>
        {data.map(feature => (
          <Feature key={feature.id} wide={isWide} data={feature} />
        ))}
      </StyledFeatureList>
    </Container>
  )
}

FeatureList.propTypes = {
  features: PropTypes.array,
  wide: PropTypes.bool,
  cmsData: PropTypes.object,
}

export default FeatureList
